// VerseLabelArrows4SearchResult.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

export default function VerseLabelArrows4Result({caller}){

  const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
  const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
  const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
  const { postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

  const dispatch = useDispatch(); // dispatch(
  const showLeftArrowVerseSearch = useSelector((state) => state.verseLabelArrows4Result.showLeftArrowVerseSearch);
  const showRightArrowVerseSearch = useSelector((state) => state.verseLabelArrows4Result.showRightArrowVerseSearch);
  const showfabContentVerseSearch = useSelector((state) => state.verseLabelArrows4Result.showfabContentVerseSearch);
  const pageNumberVerseSearch = useSelector((state) => state.verseSearch.pageNumberVerseSearch);
  const showLeftArrowNote = useSelector((state) => state.verseLabelArrows4Result.showLeftArrowNote);
  const showRightArrowNote = useSelector((state) => state.verseLabelArrows4Result.showRightArrowNote);
  const showfabContentNote = useSelector((state) => state.verseLabelArrows4Result.showfabContentNote);  
  const pageNumberNote = useSelector((state) => state.noteBookmarkList.pageNumberNote);
  const showLeftArrowNoteSearch = useSelector((state) => state.verseLabelArrows4Result.showLeftArrowNoteSearch);
  const showRightArrowNoteSearch = useSelector((state) => state.verseLabelArrows4Result.showRightArrowNoteSearch);
  const showfabContentNoteSearch = useSelector((state) => state.verseLabelArrows4Result.showfabContentNoteSearch);    
  const pageNumberNoteSearch = useSelector((state) => state.noteBookmarkList.pageNumberNoteSearch);
  const searchResultVerseList = useSelector((state) => state.verseSearch.searchResultVerseList);
  const noteBookmarkList = useSelector((state) => state.noteBookmarkList.noteBookmarkList);
  //const viewArea = useSelector((state) => state.home.viewArea);
  const userListItem = useSelector((state) => state.home.userListItem);

  const pageNumberMinus = () => {

    let pageNumber;

    switch(caller){
      case 'VerseSearch':
        pageNumber = pageNumberVerseSearch;
        break;
      case 'Note':
        pageNumber = pageNumberNote;
        break;
      case 'NoteSearch':
        pageNumber = pageNumberNoteSearch;
        break;        
    }

    switch(caller){
      case 'VerseSearch':
        dispatch(setPageNumberVerseSearch(pageNumber - 1));
        break;
      case 'Note':
        dispatch(setPageNumberNote(pageNumber - 1));
        break;
      case 'NoteSearch':
        dispatch(setPageNumberNoteSearch(pageNumber - 1));
        break;        
    }
    // if (viewArea === 'Search') {
    //   dispatch(setPageNumberVerseSearch(pageNumberVerseSearch - 1));
    // } else if (viewArea === 'Note') {
    //   dispatch(setPageNumberNote(pageNumberNote - 1));
    // }    
  }

  const pageNumberPlus = () => {   
    
    let pageNumber;

    switch(caller){
      case 'VerseSearch':
        pageNumber = pageNumberVerseSearch;
        break;
      case 'Note':
        pageNumber = pageNumberNote;
        break;
      case 'NoteSearch':
        pageNumber = pageNumberNoteSearch;
        break;        
    }    

    switch(caller){
      case 'VerseSearch':
        dispatch(setPageNumberVerseSearch(pageNumber + 1));
        break;
      case 'Note':
        dispatch(setPageNumberNote(pageNumber + 1));
        break;
      case 'NoteSearch':
        dispatch(setPageNumberNoteSearch(pageNumber + 1));
        break;        
    }    
    // if (viewArea === 'Search') {
    //   dispatch(setPageNumberVerseSearch(pageNumberVerseSearch + 1));
    // } else if (viewArea === 'Note') {
    //   dispatch(setPageNumberNote(pageNumberNote + 1));
    // }  
  }

  const FabContent = () => {

    let from;
    let to;

    let pageSize;
    let pageNumber;
    let resultTotal;

    switch(caller){
      case 'VerseSearch':
        pageSize = userListItem.VerseSearchResultPerPage;
        pageNumber = pageNumberVerseSearch;
        resultTotal = searchResultVerseList.ResultTotal;
        break;
      case 'Note':
        pageSize = userListItem.NotePerPage;
        pageNumber = pageNumberNote;
        resultTotal = noteBookmarkList.resultTotal;
        break;
      case 'NoteSearch':
        pageSize = userListItem.NotePerPage;
        pageNumber = pageNumberNoteSearch;
        resultTotal = noteBookmarkList.resultTotal;
        break;        
    }      

    switch(caller){
      case 'VerseSearch':
        if (resultTotal === 0) {
          dispatch(setShowfabContentVerseSearch(true));
          return <span>總數: 0</span>;
        } else if (resultTotal > 0) {
          dispatch(setShowfabContentVerseSearch(true));
          from = pageNumber * pageSize + 1;
          if (resultTotal >= from + pageSize) {
            to = from + pageSize - 1;
          } else {
            to = resultTotal;
          };
          return <span>{from} 至 {to} (總數: {resultTotal})</span>;
        } else {
          dispatch(setShowfabContentVerseSearch(false));
        }        
        break;
      case 'Note':
        //let pageSizeNote = userListItem.NotePerPage;
        if (resultTotal === 0) {
          dispatch(setShowfabContentNote(true));
          return <span>總數: 0</span>;
        } else if (resultTotal > 0) {
          dispatch(setShowfabContentNote(true));
          from = pageNumber * pageSize + 1;
          if (resultTotal >= from + pageSize) {
            to = from + pageSize - 1;
          } else {
            to = resultTotal;
          };
          return <span>{from} 至 {to} (總數: {resultTotal})</span>;
        } else {
          dispatch(setShowfabContentNote(false));
        }        
        break;
      case 'NoteSearch':
        if (resultTotal === 0) {
          dispatch(setShowfabContentNoteSearch(true));
          return <span>總數: 0</span>;
        } else if (resultTotal > 0) {
          dispatch(setShowfabContentNoteSearch(true));
          from = pageNumber * pageSize + 1;
          if (resultTotal >= from + pageSize) {
            to = from + pageSize - 1;
          } else {
            to = resultTotal;
          };
          return <span>{from} 至 {to} (總數: {resultTotal})</span>;
        } else {
          dispatch(setShowfabContentNoteSearch(false));
        }        
        break;        
    }
  }

  const handleOnClickLeft = () => {
    pageNumberMinus();
  };

  const handleOnClickRight = () => {
    pageNumberPlus();
  };

  useEffect(() => {

    let pageSize;
    let pageNumber;
    let resultTotal;

    switch(caller){
      case 'VerseSearch':
        pageSize = userListItem.VerseSearchResultPerPage;
        pageNumber = pageNumberVerseSearch;
        resultTotal = searchResultVerseList.ResultTotal;
        break;
      case 'Note':
        pageSize = userListItem.NotePerPage;
        pageNumber = pageNumberNote;
        resultTotal = noteBookmarkList.resultTotal;
        break;
      case 'NoteSearch':
        pageSize = userListItem.NotePerPage;
        pageNumber = pageNumberNoteSearch;
        resultTotal = noteBookmarkList.resultTotal;
        break;        
    }   

    switch(caller){
    case 'VerseSearch':
      if (resultTotal > 0) {
        if (pageNumber === 0) {
          dispatch(setShowLeftArrowVerseSearch(false));
        } else {
          dispatch(setShowLeftArrowVerseSearch(true));
        }
        if (resultTotal >= 0) {
          const _ceil = Math.ceil(resultTotal / pageSize);
          if (_ceil - 1 >= 0) {
            if (pageNumber === _ceil - 1) {
              dispatch(setShowRightArrowVerseSearch(false));
            } else {
              dispatch(setShowRightArrowVerseSearch(true));
            }
          }
        } else {
          dispatch(setShowRightArrowVerseSearch(false));
        }  
      } else {
        dispatch(setShowLeftArrowVerseSearch(false));
        dispatch(setShowRightArrowVerseSearch(false));
      }     
      break;
    case 'Note':
      //let pageSizeNote = userListItem.NotePerPage;
      if (resultTotal > 0) {
        if (pageNumber === 0) {
          dispatch(setShowLeftArrowNote(false));
        } else {
          dispatch(setShowLeftArrowNote(true));
        }
        if (resultTotal >= 0) {
          const _ceil = Math.ceil(resultTotal / pageSize);
          if (_ceil - 1 >= 0) {
            if (pageNumber === _ceil - 1) {
              dispatch(setShowRightArrowNote(false));
            } else {
              dispatch(setShowRightArrowNote(true));
            }
          }
        } else {
          dispatch(setShowRightArrowNote(false));
        }
      } else {
        dispatch(setShowLeftArrowNote(false));
        dispatch(setShowRightArrowNote(false));
      }      
      break;
    case 'NoteSearch':
      //let pageSizeNote = userListItem.NotePerPage;
      if (resultTotal > 0) {
        if (pageNumber === 0) {
          dispatch(setShowLeftArrowNoteSearch(false));
        } else {
          dispatch(setShowLeftArrowNoteSearch(true));
        }
        if (resultTotal >= 0) {
          const _ceil = Math.ceil(resultTotal / pageSize);
          if (_ceil - 1 >= 0) {
            if (pageNumber === _ceil - 1) {
              dispatch(setShowRightArrowNoteSearch(false));
            } else {
              dispatch(setShowRightArrowNoteSearch(true));
            }
          }
        } else {
          dispatch(setShowRightArrowNoteSearch(false));
        }
      } else {
        dispatch(setShowLeftArrowNoteSearch(false));
        dispatch(setShowRightArrowNoteSearch(false));
      }      
      break;      
    }   
  }, [pageNumberVerseSearch, pageNumberNote, noteBookmarkList, searchResultVerseList]);

  return (

    <div>

    <Fab
      size='small'
      sx={{
        position: 'fixed',
        left: 16,
        bottom: 32,
        backgroundColor: 'warning.light',
        color: 'white',
        boxShadow: 'none',
        // opacity: 0.7,
        '&:hover': { color: 'white', backgroundColor: 'warning.light' }, 
        display: (caller === 'VerseSearch' && showLeftArrowVerseSearch) || (caller === 'Note' && showLeftArrowNote) || (caller === 'NoteSearch' && showLeftArrowNoteSearch) ? 'flex' : 'none', 
      }}
      onClick={handleOnClickLeft}
    >
      <WestIcon />
    </Fab>

    <Fab 
      variant='extended' 
      disabled
      size='large'
      sx={{
        borderRadius: '4px',
        size: 'small',
        position: 'fixed',
        bottom: 32,
        left: '50%',          // center horizontally
        transform: 'translateX(-50%)', // adjust for the FAB's width    
        color: 'white',      
        boxShadow: 'none',
        // opacity: 0.7,
        '&.Mui-disabled': { color: 'white', backgroundColor: 'warning.light' },
        display: (caller === 'VerseSearch' && showfabContentVerseSearch) || (caller === 'Note' && showfabContentNote) || (caller === 'NoteSearch' && showfabContentNoteSearch) ? 'flex' : 'none', 
      }}        
    >
      {FabContent()}
    </Fab>

    <Fab
      size='small'
      sx={{
        position: 'fixed',
        right: 16,
        bottom: 32,
        backgroundColor: 'warning.light',
        color: 'white',
        boxShadow: 'none',
        // opacity: 0.7,
        '&:hover': { color: 'white', backgroundColor: 'warning.light' },     
        display: (caller === 'VerseSearch' && showRightArrowVerseSearch) || (caller === 'Note' && showRightArrowNote) || (caller === 'NoteSearch' && showRightArrowNoteSearch) ? 'flex' : 'none',     
      }}
      onClick={handleOnClickRight}
    >
      <EastIcon />
    </Fab>

    </div>     

  );
}